// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"78f898f7","199":"3d05b522","452":"479d560a","521":"46646574","858":"ddc21ee4","891":"11a97d3b"}[chunkId] + ".chunk.js";
};